import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutlined';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { Box, Typography } from '@mui/material';
import React from 'react';
import type { TimelineEntry, TimelineKind } from './types';

const KIND_META: Record<TimelineKind, { color: string; icon: React.ReactNode }> = {
  status: { color: 'var(--indigo)', icon: <SwapHorizIcon /> },
  note: { color: 'var(--acc)', icon: <StickyNote2OutlinedIcon /> },
  interview: { color: 'var(--amber)', icon: <EventOutlinedIcon /> },
  email: { color: 'var(--teal)', icon: <MailOutlineIcon /> },
  ai: { color: 'var(--teal)', icon: <AutoAwesomeIcon /> },
  submitted: { color: 'var(--green)', icon: <PersonAddAlt1Icon /> },
};

interface ActivityRailProps {
  /** Note composer — reuse the existing NotesSection to preserve the
   *  internal-vs-employer-visible permission toggle. */
  composer?: React.ReactNode;
  timeline: TimelineEntry[];
}

const ActivityRail: React.FC<ActivityRailProps> = ({ composer, timeline }) => (
  <Box className="cc-activity">
    <Box className="cc-activity__header">
      <Typography component="h3" className="cc-activity__title">
        Activity &amp; notes
      </Typography>
      <span className="cc-activity__filter">All</span>
    </Box>

    {composer && <Box className="cc-activity__composer">{composer}</Box>}

    <Box className="cc-activity__timeline">
      {timeline.map((entry) => {
        const meta = KIND_META[entry.kind];
        return (
          <Box key={entry.id} className="cc-activity__entry">
            <Box
              className="cc-activity__entry-icon"
              style={{ color: meta.color, background: 'color-mix(in srgb, currentColor 14%, transparent)' }}
            >
              {meta.icon}
            </Box>
            <Box className="cc-activity__entry-body">
              <div className="cc-activity__entry-text">{entry.text}</div>
              {entry.body && <div className="cc-activity__entry-quote">{entry.body}</div>}
              {entry.meta && <div className="cc-activity__entry-meta">{entry.meta}</div>}
            </Box>
          </Box>
        );
      })}
    </Box>
  </Box>
);

export default ActivityRail;
